// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"d228cc1c","580":"d27d1b5c","848":"74f33a92"}[chunkId] + ".chunk.js";
};